import { render, staticRenderFns } from "./payToday.vue?vue&type=template&id=c96754a8&"
import script from "./payToday.vue?vue&type=script&lang=js&"
export * from "./payToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports